import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';

export interface ConfirmActionDialogData {
  title: string;
  description?: string;
  confirmLabel: string;
  variant?: 'primary' | 'danger';
}

@Component({
  selector: 'app-confirm-action-dialog',
  templateUrl: './confirm-action-dialog.component.html',
  styleUrls: ['./confirm-action-dialog.component.scss'],
  standalone: false,
})
export class ConfirmActionDialogComponent implements OnDestroy {
  navigationSubs: Subscription;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmActionDialogData,
    private router: Router,
    public dialogRef: MatDialogRef<ConfirmActionDialogComponent>
  ) {
    this.navigationSubs = this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        this.dialogRef.close();
      }
    });
  }

  ngOnDestroy(): void {
    this.navigationSubs.unsubscribe();
  }
}
